import global from 'global';
import { parseEnv } from './env';

const env = parseEnv(global.navigator.userAgent, global.location.search);

export default env;
